export default __webpack_public_path__ + "static/media/misc-books1-1440w.e3f07c2f.avif";